import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'rm-progress-bars',
  template: `
    <label> {{label}}</label>
      <div class="progress">
        <div [ngClass]="'title-' + color " class="progress-bar" role="progressbar" aria-valuenow="60" aria-valuemin="0" aria-valuemax="100" [ngStyle]="{width: percent + '%'}">
          {{percent}}%
        </div>
      </div>
  `,
  styleUrls: ['./progress-bars.component.scss']
})
export class ProgressBarsComponent {
  @Input() percent = 0;
  @Input() label = '';
  @Input() color = '';
}



// WEBPACK FOOTER //
// ./src/app/resume/progress-bars.component.ts